import { Injectable } from '@angular/core';
import { BoardSummary } from 'app/trello/models/board-summary';
import { WorkerScheduler } from 'app/trello/services/worker-scheduler';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BoardSummaryMapperAsync {

  private static readonly WORKER_NAME = 'board-summary-mapper';
  private static readonly WORKER = new Worker(
    new URL(
      '../workers/board-summary-mapper.worker', // must be a literal static string!
      import.meta.url,
    ),
    {type: 'module'},
  );

  constructor(
    private readonly workerScheduler: WorkerScheduler,
  ) {
  }

  public map(
    boardSummary: BoardSummary,
  ): Observable<BoardSummary> {

    // delegate to background worker thread
    // @see: ../workers/board-summary-mapper-async.worker.ts

    this.workerScheduler.tryRegister(BoardSummaryMapperAsync.WORKER_NAME, BoardSummaryMapperAsync.WORKER);

    return this.workerScheduler.schedule<BoardSummary, BoardSummary>(BoardSummaryMapperAsync.WORKER_NAME, 'map', boardSummary);
  }

}
